import React from "react";
import { Field } from "formik";

import { FormSelect } from "../../../../../components/ui";
import { FUNDING_LOCATION } from "../constants";

const FundingLocationSelect: React.FC = () => (
  <Field
    name="funding_location"
    label="Funding Location"
    placeholder="Funding Location"
    component={FormSelect}
    options={FUNDING_LOCATION}
  />
);

export default FundingLocationSelect;
